import { IApplicationState } from '../../types/redux';

export function getGaLabel(state: IApplicationState) {
  return state.newbuilding.gaLabel;
}
